import React, { useState } from 'react';
import { Users } from 'lucide-react';
import CreateTeamForm from './CreateTeamForm';
import { Card } from '../../ui/Card';

interface CreateTeamPromptProps {
  title?: string;
  description?: string;
  /** Tighter padding for use inside dialogs (e.g. roster mapping modal). */
  compact?: boolean;
}

/**
 * Prompt shown when coach has no team.
 * Displays a card with "Create your first team" message and opens CreateTeamForm on click.
 */
const CreateTeamPrompt: React.FC<CreateTeamPromptProps> = ({
  title = 'Create your first team',
  description = 'You need to create a team before you can manage your roster or upload telemetry data.',
  compact = false,
}) => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <Card className={`text-center ${compact ? 'p-4' : 'p-8'}`}>
        <div
          className={`mx-auto flex items-center justify-center rounded-full bg-blue-100 ${compact ? 'h-12 w-12' : 'h-16 w-16'}`}
        >
          <Users className={`text-blue-600 ${compact ? 'h-6 w-6' : 'h-8 w-8'}`} />
        </div>
        <h3
          className={`font-semibold text-gray-900 ${compact ? 'mt-3 text-base' : 'mt-4 text-lg'}`}
        >
          {title}
        </h3>
        <p className={`text-gray-600 ${compact ? 'mt-1.5 text-xs' : 'mt-2 text-sm'}`}>
          {description}
        </p>
        <button
          type="button"
          onClick={() => setIsFormOpen(true)}
          className={`inline-flex items-center justify-center rounded-md border border-transparent bg-accent px-4 py-2 text-sm font-medium text-accent-foreground hover:bg-accent-hover ${compact ? 'mt-3' : 'mt-6'}`}
        >
          Create Team
        </button>
      </Card>

      <CreateTeamForm
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        onSuccess={() => {
          // Form will invalidate queries and close automatically
        }}
      />
    </>
  );
};

export default CreateTeamPrompt;
